module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff text-center"
  }, [_c('backTitleBar', {
    attrs: {
      "isBackClose": true,
      "isLogOut": true
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-img",
    attrs: {
      "src": _vm.mainImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-333 mt-25 font-bold"
  }, [_vm._v("审核失败")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 mt-20"
  }, [_vm._v("\n        请重新提交修改数据"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("失败原因：" + _vm._s(_vm.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.backToEdit
    }
  }, [_vm._v("\n        重新提交\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138a678c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/checkError.vue
// module id = UrDx
// module chunks = 51